// Firebase client configuration (public values - safe to expose)

export const firebaseConfig = {
  apiKey: 'AIzaSyDq3DolImFRFF8mDvM8Jl_-OvR_V3X4C7U',
  authDomain: 'vim-sensei.firebaseapp.com',
  projectId: 'vim-sensei',
  storageBucket: 'vim-sensei.firebasestorage.app',
  messagingSenderId: '1015284838374',
  appId: '1:1015284838374:web:cb97fabc415762c3ba7027',
};

// Declare process.env for build-time injection
declare const process: {
  env: {
    NODE_ENV?: string;
    FIREBASE_AUTH_EMULATOR_HOST?: string;
  };
};

// Check if we're in development mode
export const isDevelopment = process.env.NODE_ENV === 'development';

// Firebase Auth emulator host (only used in development)
export const authEmulatorHost = process.env.FIREBASE_AUTH_EMULATOR_HOST || '';

// Config is always valid since it's hardcoded
export function isFirebaseConfigValid(): boolean {
  return true;
}
